"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const makeCanTakeAny = buffers => () => {
  return buffers.find(buffer => buffer.canTake());
};

var _default = makeCanTakeAny;
exports.default = _default;
module.exports = exports["default"];